import type { FormattedText } from '../utils';
import type { UniclientBaseComponentProps, UniclientWizardComponentBase } from './types';

export enum ProgressCardIcon {
  Diamond = 'diamond',
}

export interface ProgressCardProps extends UniclientBaseComponentProps {
  readonly title: FormattedText;
  /** Range from 0-1 */
  readonly progress: number;
  readonly progressIcon?: ProgressCardIcon;
}

export type WizardProgressCardProps = ProgressCardProps & UniclientWizardComponentBase<'progress_card'>;

export function progressCard(props: ProgressCardProps): WizardProgressCardProps {
  return { progressIcon: ProgressCardIcon.Diamond, ...props, type: 'progress_card' };
}
